import * as React from 'react';

import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import Grid from '@mui/material/Grid';
import { DataGrid, GridRowsProp, GridColDef,GridRowId,GridToolbar,GridRowSelectionModel, GridRenderCellParams } from '@mui/x-data-grid';
import CircularProgress from '@mui/material/CircularProgress';
import IconButton from '@mui/material/IconButton';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import StopCircleIcon from '@mui/icons-material/StopCircle';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

import dayjs, { Dayjs } from 'dayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/el';

import {useAuth, getAsUserInfo} from '../../context/AuthContext'
import {Ibu, Iuserinfo,iauthData} from '../../context/AuthContextTypes'

import classes from '../../components/Cart/cart.module.scss';
import { returnBasenameUrl } from '../../utils';
import {
    claimRenderStatus,
    CLAIM_STATUS_OPTIONS
  } from '../components/cell-renderers';

import theme from '../../theme';

dayjs.locale('el'); // Set global locale to Greek

type WarrClaimrHT = {
    COMPANY: number;
    FINDOC: number;
    FINCODE: string;
    QTY1: number;
    TRNDATE: string;
    TRDR: number;
    TRDBRANCH: number;
    TRDCODE: number;
    TRDNAME: string;
    ISCANCEL: number;
    ISPRINT: number;
    APPRV: number;
    FULLYTRANSF: number;
    FINSTATES: number;
    BUSUNITS: number;
    SUMAMNT : number;
    QTYPEND: number;
}

/*
	{
  "claimid":67832,
  "claimdate":"2025-10-30",
  "warrclaimdate":"2025-10-28",
  "vin":"VB4ET9009NY000207",
  "custname":"Στυλιανοπολους θανάσης",
	"wclaimstate":101,
  "wclaimstatus":"ΥΠΟΒΛΗΘΗΚΕ",
  "faultcode":"00002215152",
  "mainitemcode":"00002215152",
  "mainitemname":"Σινεμπλόκ 9x12x23,5"
  }
*/
export const claidocexample = {
  claimid: 1,
  claimdoc: "FINCODE",
  claimdate: "2025-10-30",
  warrclaimdate: "2025-10-28",
  vin: "VB4ET9009NY000207",
  custname: "Στυλιανοπολους θανάσης",
  wclaimstate: 101,
  wclaimstatus: "ΥΠΟΒΛΗΘΗΚΕ",
  faultcode: "00002215152",
  mainitemcode: "00002215152",
  mainitemname: "Σινεμπλόκ 9x12x23,5"
}
type WarrClaimDocT ={
  claimid: number;
  claimdoc: string;
  claimdate: string;
  warrclaimdate: string;
  vin: string;
  custname: string;
  wclaimstate: number;
  wclaimstatus: string;
  faultcode: string;
  mainitemcode: string;
  mainitemname: string;
}
/*
  {
"success":true,
"reply":"getwarrclaims_reply",
"totalcount":2,
"procstep":0,
"data":[
	{
	"claimid":69586,
	"claimdate":"2025-12-14",
	"warrclaimdate":"2025-12-14",
	"vin":"HL4PMSAB0SZ000326",
	"custname":"stylianopoulos",
	"wclaimstate":0,
	"wclaimstatus":"",
	"faultcode":"00003515370",
	"mainitemcode":"00003515370",
	"mainitemname":"Ροδέλα"
	},
	{"claimid":67832,"claimdate":"2025-10-30","warrclaimdate":"2025-10-28","vin":"VB4ET9009NY000207","custname":"Στυλιανοπολους θανάσης",
	"wclaimstate":101,"wclaimstatus":"ΥΠΟΒΛΗΘΗΚΕ","faultcode":"00002215152","mainitemcode":"00002215152","mainitemname":"Σινεμπλόκ 9x12x23,5"}]}

*/

type GetWarrClaimsResponseType = {
    success: boolean,
    reply?: string,
    totalcount?: number,
    procstep?: number,
    data?: WarrClaimDocT[],
    error?: string,
    request?: Object
}
type GetWarrClaimDocLineType = {
  sodt: number,
	sodtname: string,
	code:string,
	name:string,
	code2:string,
	lbrcodename:string,
	lbrnotes:string,
	qty:number,
}

type WarrClaimDocDetailsT = {
  claimid: number,
	claimdate: string,
	warrclaimdate: string,
	vin: string,
	custname: string,
	wclaimstate:101,
	wclaimstatus: string,
	faultcode: string,
	faultypegrpnm: string,
	mainitemcode: string,
	mainitemname: string,
	faultypecode: string,
	faultypename: string,
	troublegroupnm: string,
	troublecode: string,
	troublename: string,
	reasongroupnm: string,
	reasoncode: string,
	reasonname: string,
	custaddr: string,
	custzip: string,
	custcity: string,
	custcountry: string,
	custmobile: string,
	custemail: string,
  remarks?: string, 
	asnotes?: string,
  lines?:GetWarrClaimDocLineType[]
}
type GetWarrClaimDocResponseType= {
    success: boolean,
    reply?: string,
    totalcount?: number,
    procstep?: number,
   data:WarrClaimDocDetailsT[]
}

function WarrClaims() {
    let auth = useAuth();
    const [locale, setLocale] = React.useState<string>('el');
    const [warrclaims, setWarrclaims] = React.useState<WarrClaimDocT[]>([])
    const [isloading, setIsloading] = React.useState(false)
    const [showdetails, setShowdetails]= React.useState(false)
    const [warrclaim, setWarrclaim] = React.useState<WarrClaimDocT | {}>({})
    const [warrclaimdocdet, setWarrclaimdocdet] = React.useState<WarrClaimDocDetailsT | {}>({})
    const [asuinfo, Setasuinfo]=React.useState(getAsUserInfo(auth))
    const [fromclaimdate, Setfromclaimdate] = React.useState<Dayjs | null>(dayjs().subtract(3, 'month'))
    const [toclaimdate, Settoclaimdate] = React.useState<Dayjs | null>(dayjs())

    function fetchWarrClaims() {
        if(auth.userData.success!==true) return
        if(auth.userData.aftersaccesslevel===undefined || auth.userData.aftersaccesslevel===null || auth.userData.aftersaccesslevel<1) {
            console.log('WarrClaims fetchWarrClaims(), not auth for as access')
            return
        }
        if(`${asuinfo.bu}`!==process.env.REACT_APP_AFTERSBU || asuinfo.trdr<=0 ) {alert('Bad user information');return;}
        if(`${asuinfo.bu}`!==process.env.REACT_APP_AFTERSBU || asuinfo.trdr<=0 ) {alert('Bad user information');return;}

        setIsloading(true);
        let fromdatestr = fromclaimdate ? fromclaimdate.format('YYYY-MM-DD') : ''
        let todatestr = toclaimdate ? toclaimdate.format('YYYY-MM-DD') : ''
        let usercode = auth.userData.username
        let token = auth.userData.token
        let postdata = {
          service: "getwarrclaims", 
          usercode: usercode,
          // vin: warrclaimState.vin,
          clientid: token,
          trdr: asuinfo.trdr,
          trdbranch:asuinfo.trdbranch,
          accesslevel: asuinfo.accesslevel,
          userid: auth.userData.userid,
          webservice: asuinfo.WEBSERVICE, 
          bu: asuinfo.bu,
          fromdate: fromdatestr,
          todate: todatestr
        }
        let body = JSON.stringify(postdata)
        const ms = Date.now();
        let basename=returnBasenameUrl()
        let url =`${basename}${process.env.REACT_APP_B2B_API_URL}?_t=${ms}`;
        fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json','Cache-Control': 'no-cache' },
          body: body , cache: "no-store"
        })
        .then((response) =>  {
          if (!response.ok) return {} 
          else return response.json()
        })
        .then((data:any) => {
          const isSuccessClaimsResponse = (data: any): data is GetWarrClaimsResponseType =>
                      typeof data === 'object' && data !== null && data.hasOwnProperty('success') && typeof data.success === 'boolean' ;
          if (isSuccessClaimsResponse(data) && data.success!==true)
          {
            alert('Η εύρεση Εγγυήσεων απέτυχε.')
          }
          else {
            // console.log("data.hasOwnProperty('totalcount')",data.hasOwnProperty('totalcount'),"typeof data.totalcount",typeof data.totalcount)
            if(data.hasOwnProperty('totalcount') && typeof data.totalcount === 'number' && typeof data.data === 'object'){
              if( data.totalcount<=0) {
                alert('Η εύρεση Εγγυήσεων απέτυχε (query return empty, non existing vin')
              }
              else {
                setWarrclaims(data.data || []);
              }
            }
            else {
              alert('Η εύρεση Εγγυήσεων δεν είχε αποτέλεσμα.')
            }
          }
        })
        .finally(() => {
          setIsloading(false);
        });
    }
  /*
	{
  "claimid":67832,
  "claimdoc": "FINCODE",
  "claimdate":"2025-10-30",
  "warrclaimdate":"2025-10-28",
  "vin":"VB4ET9009NY000207",
  "custname":"Στυλιανοπολους θανάσης",
	"wclaimstate":101,
  "wclaimstatus":"ΥΠΟΒΛΗΘΗΚΕ",
  "faultcode":"00002215152",
  "mainitemcode":"00002215152",
  "mainitemname":"Σινεμπλόκ 9x12x23,5"
  }
 100	ΑΔΙΑΦΟΡΟ
101	ΥΠΟΒΛΗΘΗΚΕ
102	ΕΛΕΓΧΘΗΚΕ
103	ΕΓΚΡΙΘΗΚΕ
104	ΑΚΥΡΩΘΗΚΕ
105	ΟΛΟΚΛΗΡΩΘΗΚΕ
111	ΕΚΚΡΕΜΟΤΗΤΕΣ 
*/
    const WarrClaimsListColumns : GridColDef[] = [  // , width: 150
        { field: 'claimdate',
          type: 'string',
          headerName: 'Ημερομηνία',
          disableReorder: true,
          hideable: false,
          flex:1
        },
        {
          field: 'claimdoc',
          type: 'string',
          headerName: 'Παραστατικό',
          disableReorder: true,
          hideable: false,
          flex:1
        },
        { field: 'warrclaimdate',
        type: 'string',
        headerName: 'Ημ.Εγγύησης',
        disableReorder: true,
        hideable: false,
        flex:1
        },
        { field: 'vin',
            type: 'string',
            headerName: 'Πλαίσιο',
            disableReorder: true,
            hideable: false,
            flex:2
        },
        { field: 'mainitemname',
            type: 'string',
            headerName: 'Βασική Αιτία',
            disableReorder: true,
            hideable: false,
            flex:2
        },
        {
          field: 'wclaimstatus',
          type: 'string',
          headerName: 'Κατάσταση',
          disableReorder: true,
          hideable: false,
          flex:1,
          //renderCell: (params: GridRenderCellParams<any, number>) => (
          //  <strong>
          //      {params.value ? params.value.toLocaleString('el-GR', { minimumFractionDigits: 2, maximumFractionDigits: 2 } ) : params.value }
          //   </strong>
          //  ),
        },
        {
            field: 'wclaimstate',
            //  ['none', 'submitted', 'checked', 'approved','canceled','completed','pending']
            //  100	ΑΔΙΑΦΟΡΟ 101	ΥΠΟΒΛΗΘΗΚΕ 102	ΕΛΕΓΧΘΗΚΕ 103	ΕΓΚΡΙΘΗΚΕ 104	ΑΚΥΡΩΘΗΚΕ 105	ΟΛΟΚΛΗΡΩΘΗΚΕ 111	ΕΚΚΡΕΜΟΤΗΤΕΣ
            valueGetter: (value, row:WarrClaimDocT) => {
              if(row.wclaimstate===100) return 'none'
              else if(row.wclaimstate===101) return 'submitted'
              else if(row.wclaimstate===102) return 'checked'
              else if(row.wclaimstate===103) return 'approved' 
              else if(row.wclaimstate===104) return 'canceled'
              else if(row.wclaimstate===111) return 'pending'
              else if(row.wclaimstate===106) return 'PatrsSent'
              else return `${row.wclaimstatus || ''}`;
            },
            headerName: 'Status',
            renderCell: claimRenderStatus,
            valueOptions: CLAIM_STATUS_OPTIONS,
            width: 150,
            editable: false,
          },
        {
          field: 'claimid',
          type: 'number',
          headerName: ' X ',
          disableReorder: true,
          hideable: false,
          flex:1,
          renderCell: (params: GridRenderCellParams<any, number>) => (
            <strong>
                <IconButton color="primary" aria-label="zoom to order" tabIndex={params.hasFocus ? 0 : -1}
                  onClick={(e)=>{ handleZoomToOrderRow(e, params.row) }}>
                  <ZoomInIcon />
                </IconButton>
              </strong>
            ),
        }
    ]
    type Order = 'asc' | 'desc';
    function getRowId(row:WarrClaimDocT) {
      return row.claimid;
    }

   function retrieveWarrclaimDetails(rowboj:WarrClaimDocT){

      setWarrclaim(rowboj)
      setWarrclaimdocdet({})
        if(auth.userData.success!==true) return
        if(auth.userData.aftersaccesslevel===undefined || auth.userData.aftersaccesslevel===null || auth.userData.aftersaccesslevel<1) {
            console.log('WarrClaims fetchWarrClaims(), not auth for as access')
            return
        }
        if(`${asuinfo.bu}`!==process.env.REACT_APP_AFTERSBU || asuinfo.trdr<=0 ) {alert('Bad user information');return;}
        if(`${asuinfo.bu}`!==process.env.REACT_APP_AFTERSBU || asuinfo.trdr<=0 ) {alert('Bad user information');return;}
        setIsloading(true);
        let fromdatestr = fromclaimdate ? fromclaimdate.format('YYYY-MM-DD') : ''
        let todatestr = toclaimdate ? toclaimdate.format('YYYY-MM-DD') : ''
        let usercode = auth.userData.username
        let token = auth.userData.token
        let postdata = {
          service: "getwarrclaimdetails", 
          usercode: usercode,
          // vin: warrclaimState.vin,
          clientid: token,
          trdr: asuinfo.trdr,
          trdbranch:asuinfo.trdbranch,
          accesslevel: asuinfo.accesslevel,
          userid: auth.userData.userid,
          webservice: asuinfo.WEBSERVICE, 
          bu: asuinfo.bu,
          claimid: rowboj.claimid
        }
        let body = JSON.stringify(postdata)
        const ms = Date.now();
        let basename=returnBasenameUrl()
        let url =`${basename}${process.env.REACT_APP_B2B_API_URL}?_t=${ms}`;
        fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json','Cache-Control': 'no-cache' },
          body: body , cache: "no-store"
        })
        .then((response) =>  {
          if (!response.ok) return {} 
          else return response.json()
        })
        .then((data:any) => {
          const isSuccessClaimDocResponse = (data: any): data is GetWarrClaimDocResponseType =>
                typeof data === 'object' && data !== null && data.hasOwnProperty('success') && typeof data.success === 'boolean' ;
          if (isSuccessClaimDocResponse(data) && data.success!==true)
          {
            alert('Η εύρεση του Δελτίου Εγγύησης απέτυχε.')  
            // setWarrclaim(rowboj)
            setWarrclaimdocdet({})
          }
          else {
            // console.log("data.hasOwnProperty('totalcount')",data.hasOwnProperty('totalcount'),"typeof data.totalcount",typeof data.totalcount)
            if(data.hasOwnProperty('totalcount') && typeof data.totalcount === 'number' && typeof data.data === 'object'){
              if( data.totalcount<=0) {
                alert('Η εύρεση του Δελτίου Εγγύησης απέτυχε (query return empty, non existing vin')
              }
              else {
                // setWarrclaims(data.data || []);
                console.log("okey data.data", data.data);
                setWarrclaimdocdet(data.data[0] || {});
                setShowdetails(true);
              }
            }
            else {
              setWarrclaimdocdet({})
                              console.log("no data data.data", data.data);
              alert('Η εύρεση του Δελτίου Εγγύησης δεν είχε αποτέλεσμα.')
            }
          }
        })
        .finally(() => {
          setIsloading(false);
        });
  
      }

    function handleCloseDetails()
    {
        // setOrder({})
        setShowdetails(false)
    }


    function handleZoomToOrderRow(e: React.MouseEvent<HTMLButtonElement, MouseEvent>, rowboj:WarrClaimDocT){
        retrieveWarrclaimDetails(rowboj)
    }

    React.useEffect(()=>{
      console.log('=JS WarrClaims=, useeffect[] called..., fetchWarrClaims...')
      fetchWarrClaims();
    },[])


    return (
      <>
      <section>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={locale}>
          <DatePicker
            label="Από Ημερομηνία"
            value={fromclaimdate}
            onChange={(newValue) => Setfromclaimdate(newValue)}
          />
          <DatePicker
            label="Έως Ημερομηνία"
            value={toclaimdate}
            onChange={(newValue) => Settoclaimdate(newValue)}
          />
        </LocalizationProvider>
         <Button variant="contained" color="primary" onClick={fetchWarrClaims} style={{marginLeft:theme.spacing(2), marginTop:theme.spacing(1)}}>
          Αναζήτηση
         </Button>
      </section>

    <section className={classes.cart}>
      <h1>Δελτία Εγγύησης</h1>
      {isloading===true && <CircularProgress />}
      
      {showdetails === false && <div className={classes.container}>
      <DataGrid rows={warrclaims} columns={WarrClaimsListColumns} getRowId={getRowId} density={'compact'}
        initialState={{
          pagination: { paginationModel: { pageSize: 25 } },
        }}
        pageSizeOptions={[25, 50]}
        disableColumnMenu        
        checkboxSelection={false}   
        disableMultipleRowSelection={true}
        onRowSelectionModelChange = {(rowSelectionModel, details) => {
        }}
        slots={{ toolbar: GridToolbar }}
        slotProps={{
          columnsManagement: {
            toggleAllMode: 'filteredOnly',          
          },       
          filterPanel: {
            disableAddFilterButton: true,
            disableRemoveAllButton: true,
          },
          toolbar: {printOptions: { disableToolbarButton: true },csvOptions: { disableToolbarButton: true },}
        }} 
      />
      </div> }

    {showdetails === true && <div className={classes.container}>
      <WarrclaimDetails selectedclaim={warrclaim} warrclaimdoc={warrclaimdocdet} cbf={handleCloseDetails} />
    </div> }

    </section>

    </>
    )
}

  // const [warrclaim, setWarrclaim] = React.useState<WarrClaimDocT | {}>({})
  // const [warrclaimdocdet, setWarrclaimdocdet] = React.useState<WarrClaimDocDetailsT | {}>({})
const bull = (
  <Box
    component="span"
    sx={{ display: 'inline-block', mx: '2px', transform: 'scale(0.8)' }}
  >
    •
  </Box>
);

type WarrclaimDetailsProps = {
    selectedclaim: WarrClaimDocT | {};
    warrclaimdoc: WarrClaimDocDetailsT | {};
    cbf: Function
}

const WarrclaimDetails = (props:WarrclaimDetailsProps) => {

  function handleClosebtn(){
        props.cbf()
  }
  let Title1 = 'Δελτίο Εγγύησης : ';
  let customername = '';
  let vin ='';
  let faultcode ='';
  let faultypegrpnm ='';
  let mainitemcode ='';
  let mainitemname ='';
  let faultypename ='';
  let troublegroupnm ='';
  let troublename ='';
  let reasongroupnm ='';
  let reasonname ='';
  let remarks ='';
  let asnotes ='';
  const isselectedclaimT = (obj: any): obj is WarrClaimDocT => typeof obj === 'object'
  if(isselectedclaimT(props.selectedclaim)) {
      let selectedClaimob:WarrClaimDocT = props.selectedclaim;
      if(selectedClaimob.hasOwnProperty('claimdoc'))
        Title1 += `${selectedClaimob.claimdoc} `;
      if(selectedClaimob.hasOwnProperty('claimdate'))
        Title1 += `${selectedClaimob.claimdate} `;
      if(selectedClaimob.hasOwnProperty('wclaimstatus'))
        Title1 += `${selectedClaimob.wclaimstatus} `;
      if(selectedClaimob.hasOwnProperty('custname'))
        customername= `${selectedClaimob.custname} `;
  }
  const iswarrclaimdocT = (obj: any): obj is WarrClaimDocDetailsT => typeof obj === 'object'
  if(iswarrclaimdocT(props.warrclaimdoc)) {
      let warrclaimdoc:WarrClaimDocDetailsT = props.warrclaimdoc;
      if(warrclaimdoc.hasOwnProperty('vin'))
        vin = `${warrclaimdoc.vin} `;
      if(warrclaimdoc.hasOwnProperty('faultcode'))      // τύπος προβλήματος
        faultcode= `${warrclaimdoc.faultcode} `;
      if(warrclaimdoc.hasOwnProperty('mainitemcode'))
        mainitemcode= `${warrclaimdoc.mainitemcode} `;
      if(warrclaimdoc.hasOwnProperty('mainitemname'))
        mainitemname= `${warrclaimdoc.mainitemname} `;

      if(warrclaimdoc.hasOwnProperty('faultypegrpnm')) // omada typou blabhs
        faultypegrpnm= `${warrclaimdoc.faultypegrpnm} `;
      if(warrclaimdoc.hasOwnProperty('faultypename')) //Τύπος Βλάβης
        faultypename= `${warrclaimdoc.faultypename} `;

      if(warrclaimdoc.hasOwnProperty('troublegroupnm'))   // Trouble Codes
        troublegroupnm= `${warrclaimdoc.troublegroupnm} `; 
      if(warrclaimdoc.hasOwnProperty('troublename'))
        troublename= `${warrclaimdoc.troublename} `;

      if(warrclaimdoc.hasOwnProperty('reasongroupnm'))  //   Reason Codes
        reasongroupnm= `${warrclaimdoc.reasongroupnm} `;
      if(warrclaimdoc.hasOwnProperty('reasonname'))
        reasonname= `${warrclaimdoc.reasonname} `;

      if(warrclaimdoc.hasOwnProperty('remarks'))
        remarks= `${warrclaimdoc.remarks} `;
      if(warrclaimdoc.hasOwnProperty('asnotes'))
        asnotes= `${warrclaimdoc.asnotes} `;
  }
  /*  
  	faultcode: string,
	faultypegrpnm: string,
	mainitemcode: string,
	mainitemname: string,
	faultypecode: string,
	faultypename: string,
	troublegroupnm: string,
	troublecode: string,
	troublename: string,
	reasongroupnm: string,
	reasoncode: string,
	reasonname: string,
	custaddr: string,
	custzip: string,
	custcity: string,
	custcountry: string,
	custmobile: string,
	custemail: string,
  remarks?: string, 
	asnotes?: string,
  lines?:GetWarrClaimDocLineType[]
  */

  return(
  <>
  <Box component="section" sx={{ p: 2, border: '1px dashed grey' }}>
     <Card sx={{ minWidth: 275 }}>
      <CardContent>
        <Typography variant="h5" component="div">
                  {`${Title1}`}
        </Typography>
        {/* <Typography sx={{ color: 'text.secondary', mb: 1.5 }}>adjective</Typography> */}
        <Typography variant="body2">
          {bull}Πλαίσιο: {vin} <br />
          {bull}Tύπος προβλήματος: {faultcode} {mainitemcode} {mainitemname} <br />
          {bull}Tύπος βλάβης: {faultypegrpnm} {faultypename} <br />
          {bull}Trouble Code: {troublegroupnm} {troublename} <br />
          {bull}Reason Code: {reasongroupnm} {reasonname}
        </Typography>
        <Typography sx={{ color: 'text.secondary', mb: 1.5 }}><b>Παρατηρήσεις:</b> {remarks}</Typography>
        <Typography sx={{ color: 'text.secondary', mb: 1.5 }}><b>Παρατηρήσεις Τεχνικού Τμήματος:</b> {asnotes}</Typography>
      </CardContent>
    </Card>

  </Box>
  <Box>
    <Button variant="contained" endIcon={<StopCircleIcon />} color="warning" onClick={(e)=>{handleClosebtn()}} >κλεισιμο</Button>
  </Box>
  </>)
}

export default WarrClaims;